'use client';
import '@/app/style/servicesetyle.module.css';
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaPhoneAlt,
  FaPinterest,
} from 'react-icons/fa';
import { IoMail } from 'react-icons/io5';
import { FaXTwitter } from 'react-icons/fa6';
import Hero from './Hero';
import log2 from '../../../public/updated-home/logo/Logo_Header.svg';
import { Fragment, useState, useRef } from 'react';
import { Dialog, Disclosure, Popover, Transition } from '@headlessui/react';
import {
  Bars3Icon,
  ChartPieIcon,
  CursorArrowRaysIcon,
  FingerPrintIcon,
  SquaresPlusIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import {
  ChevronDownIcon,
  PhoneIcon,
  PlayCircleIcon,
  RectangleGroupIcon,
} from '@heroicons/react/20/solid';
import Image from 'next/image';
import Link from 'next/link';

const products = [
  {
    name: 'Airport Car Service',
    description: 'Elevate your events with elite rides',
    href: '/services/airport-car-service',
    icon: SquaresPlusIcon,
  },

  {
    name: 'City to City Rides',
    description: 'Travel between cities in luxury & ease',
    href: '/services/city-to-city',
    icon: ChartPieIcon,
  },
  {
    name: 'Chauffeur Services',
    description: 'Professional drivers at your service.',
    href: '/services/chauffeur-service',
    icon: CursorArrowRaysIcon,
  },

  {
    name: 'Hourly Hire',
    description: 'Hire by the hour for flexibility.',
    href: '/services/hourly-car-service',
    icon: FingerPrintIcon,
  },

  {
    name: 'City Tours',
    description: 'Stress-free airport pick-ups & drop-offs',
    href: '/services/city-tour',
    icon: SquaresPlusIcon,
  },

  {
    name: 'Special Events',
    description: 'Elevate your events with elite rides',
    href: '/services/special-events',
    icon: SquaresPlusIcon,
  },

  {
    name: 'Point to Point Car Service',
    description: 'Elevate your events with elite rides',
    href: '/services/point-to-point',
    icon: SquaresPlusIcon,
  },
];

const Business = [
  {
    name: 'Corporate  Airport Transfers ',
    description: 'Speak directly to your customers with our engagement tool',
    href: '/services/corporate-airport-transfer',
    icon: CursorArrowRaysIcon,
  },

  {
    name: 'Client & Partner Travel',
    description: 'Your customers’ data will be safe and secure',
    href: '/services/client-partner',
    icon: SquaresPlusIcon,
  },

  {
    name: 'Corporate Event Transportation',
    description: 'Get a better understanding where your traffic is coming from',
    href: '/services/corporate-events',
    icon: ChartPieIcon,
  },

  // {
  //   name: 'Roadshows and Financial Tours',
  //   description: 'Get a better understanding where your traffic is coming from',
  //   href: '#',
  //   icon: ChartPieIcon,
  // },

  {
    name: 'Meetings & Offsite Events',
    description: 'Your customers’ data will be safe and secure',
    href: '/services/meetings-and-offsite-events',
    icon: FingerPrintIcon,
  },

  //  { name: 'Credit afflation',
  //  description: 'Your customers’ data will be safe and secure',
  //  href: '#', icon: FingerPrintIcon },
];

const contact = [
  {
    title: '(888) 346-9886',
    href: 'tel:+18883469886',
    icon: <FaPhoneAlt />,
  },
  {
    title: 'contact@prestigeride.com',
    href: 'mailto:contact@prestigeride.com',
    icon: <IoMail />,
  },
];
const social = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/prestigeridelimo',
    icon: <FaFacebook />,
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/prestigerideservices/',
    icon: <FaInstagram />,
  },
  {
    name: 'X',
    href: 'https://twitter.com/PrestigeRide',
    icon: <FaXTwitter />,
  },
  {
    name: 'X',
    href: 'https://www.pinterest.com/prestigerideservices/',
    icon: <FaPinterest />,
  },
  // {
  //   name: "GitHub",
  //   href: "#",
  //   icon: (props) => (
  //     <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
  //       <path
  //         fillRule="evenodd"
  //         d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
  //         clipRule="evenodd"
  //       />
  //     </svg>
  //   ),
  // },
  // {
  //   name: "YouTube",
  //   href: "#",
  //   icon: (props) => (
  //     <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
  //       <path
  //         fillRule="evenodd"
  //         d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
  //         clipRule="evenodd"
  //       />
  //     </svg>
  //   ),
  // },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Example() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showConsumerOptions, setShowConsumerOptions] = useState(false);
  const [showBusinessOptions, setShowBusinessOptions] = useState(false);
  const [showCompanyOptions, setShowCompanyOptions] = useState(false);

  const [showSecondDropdown, setShowSecondDropdown] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const leaveTimeoutRef = useRef(null);
  const [showConsumerDropdown, setShowConsumerDropdown] = useState(false);
  const [showBusinessDropdown, setShowBusinessDropdown] = useState(false);
  const [selectedConsumerOption, setSelectedConsumerOption] = useState(null);
  const [selectedBusinessOption, setSelectedBusinessOption] = useState(null);
  const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);
  const [selectedCompanyOption, setSelectedCompanyOption] = useState(null);

  const handleConsumerMouseEnter = () => {
    setShowConsumerDropdown(true);
  };

  const handleConsumerMouseLeave = () => {
    setShowConsumerDropdown(false);
  };

  const handleBusinessMouseEnter = () => {
    setShowBusinessDropdown(true);
  };

  const handleBusinessMouseLeave = () => {
    setShowBusinessDropdown(false);
  };

  const handleConsumerOptionSelect = (index) => {
    setSelectedConsumerOption(index);
    setMobileMenuOpen(false);
  };

  const handleBusinessOptionSelect = (index) => {
    setSelectedBusinessOption(index);
    setMobileMenuOpen(false);
  };
  const handleCompanyMouseEnter = () => {
    setShowCompanyDropdown(true);
  };

  const handleCompanyMouseLeave = () => {
    setShowCompanyDropdown(false);
  };

  const handleCompanyOptionSelect = (index) => {
    setSelectedCompanyOption(index);
    setMobileMenuOpen(false);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setDropdownOpen(false);
  };

  // Clear the timeout when the mouse enters the dropdown
  const handleDropdownMouseEnter = () => {
    clearTimeout(leaveTimeoutRef.current);
  };

  const handleMouseEnter = () => {
    console.debug('Mouse Enter');
    setDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    console.debug('Mouse Leave');
    // Increasing the timeout to 300 milliseconds
    leaveTimeoutRef.current = setTimeout(() => {
      setDropdownOpen(false);
    }, 300);
  };

  return (
    <div className=" relative isolate mobile-shadow z-10 bg-white">
      <nav className="mx-auto  max-w-7xl lg:flex lg:justify-between text-black p-4">
        {/* Logo and Mobile Menu Button */}
        <div className="flex justify-between">
          <div className=" flex    justify-center sm:justify-center md:justify-center lg:justify-start">
            <span className="sr-only">Your Company</span>
            <Link href="/">
              <svg
                width="320"
                height="26"
                viewBox="0 0 320 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M44.2246 25.2041L39.4473 17.3454H32.1528V25.2041H26.2088V1.01771H41.1594C42.9336 1.01771 44.4648 1.37543 45.753 2.07423C47.0582 2.77304 48.0583 3.74083 48.7703 4.9776C49.4681 6.19774 49.8325 7.61199 49.8325 9.18985C49.8325 10.8564 49.4229 12.3317 48.5895 13.6101C47.7702 14.8912 46.739 15.8119 45.4959 16.3776L51.0304 25.2041H44.2218H44.2246ZM43.1172 11.3916C43.6314 10.8703 43.8913 10.141 43.8913 9.18985C43.8913 8.2387 43.6031 7.49275 43.0579 6.97142C42.5126 6.46673 41.8741 6.19774 41.1622 6.19774H32.1557V12.1653H41.1622C41.9504 12.1653 42.603 11.8963 43.1172 11.3916Z"
                  fill="#2B3252"
                />
                <path
                  d="M55.8275 1.01771H77.7985V6.19774H61.7715V10.5292H69.9559V15.7093H61.7715V20.0269H77.7985V25.2069H55.8275V1.01771Z"
                  fill="#2B3252"
                />
                <path
                  d="M89.7827 25.2041C88.2204 24.7716 86.8418 24.2225 85.658 23.5209C84.4602 22.8221 83.4431 21.9874 82.5956 21.0196L86.3248 16.9849C86.87 17.5811 87.5368 18.1301 88.3108 18.6681C89.0849 19.2061 90.0257 19.6664 91.1303 20.0685C92.2208 20.4706 93.4667 20.6785 94.8454 20.6785C96.1506 20.6785 97.3174 20.4844 98.3485 20.099C99.3656 19.7274 100.168 19.2948 100.73 18.7901C101.292 18.2854 101.58 17.8528 101.58 17.4812C101.58 17.0486 101.338 16.7214 100.869 16.4996C100.4 16.2777 99.7159 16.1114 98.8203 16.0088C97.9248 15.9034 96.9247 15.8146 95.8031 15.7564C94.7267 15.6982 93.6193 15.6233 92.4836 15.5041C91.3479 15.3848 90.2404 15.1907 89.164 14.9245C88.1018 14.6555 87.1328 14.2534 86.2513 13.7182C85.3727 13.183 84.6749 12.4676 84.1579 11.5608C83.6268 10.6679 83.3697 9.53648 83.3697 8.1666C83.3697 6.79672 83.8386 5.53221 84.7794 4.34258C85.7202 3.15295 87.0395 2.19902 88.7516 1.46971C90.4805 0.740401 92.5118 0.368814 94.8764 0.368814C96.6817 0.368814 98.3033 0.562927 99.7131 0.948379C101.123 1.35047 102.366 1.85516 103.414 2.49573C104.476 3.11967 105.431 3.89612 106.31 4.8029L102.518 8.52432C101.821 7.90039 101.14 7.39292 100.47 6.97696C99.8176 6.56101 99.0605 6.21715 98.1819 5.96481C97.3032 5.69582 96.241 5.57658 94.9669 5.57658C93.3594 5.57658 91.9185 5.85943 90.6755 6.439C89.4155 7.01856 88.7939 7.6009 88.7939 8.1666C88.7939 8.67129 89.068 9.07338 89.5963 9.35623C90.1415 9.63908 90.9156 9.86092 91.9016 10.0107C92.8876 10.1604 93.995 10.2797 95.207 10.3823C96.5405 10.5015 97.905 10.6512 99.2695 10.8592C100.648 11.0672 101.922 11.3944 103.106 11.8575C104.29 12.3178 105.259 13.0028 106.019 13.8957C106.776 14.7886 107.14 15.9782 107.14 17.484C107.14 18.9898 106.654 20.3264 105.685 21.6075C104.699 22.8887 103.304 23.9147 101.47 24.7022C99.6368 25.4759 97.436 25.8641 94.8736 25.8641C93.0401 25.8641 91.3394 25.6395 89.7799 25.2097L89.7827 25.2041Z"
                  fill="#2B3252"
                />
                <path
                  d="M122.616 25.2041V6.19774H111.94V1.01771H139.251V6.19774H128.561V25.2041H122.616Z"
                  fill="#2B3252"
                />
                <path
                  d="M144.048 25.2041V6.09791H149.992V25.2041H144.048Z"
                  fill="#2B3252"
                />
                <path
                  d="M162.247 24.2059C159.911 23.105 158.092 21.5853 156.772 19.6664C155.453 17.7308 154.786 15.5595 154.786 13.1165C154.786 10.6734 155.453 8.48827 156.772 6.56656C158.092 4.63097 159.911 3.12799 162.247 2.02709C164.584 0.909557 167.282 0.360495 170.344 0.360495C172.347 0.360495 174.438 0.793089 176.653 1.64164C178.868 2.49019 180.656 3.65209 182.035 5.09407L178.139 9.33682C177.243 8.3108 176.076 7.47611 174.605 6.86604C173.133 6.24211 171.587 5.94262 169.98 5.94262C168.191 5.94262 166.612 6.22547 165.219 6.80504C163.824 7.37074 162.716 8.18878 161.928 9.26195C161.126 10.3323 160.73 11.6135 160.73 13.1165C160.73 14.6195 161.154 15.884 161.99 16.9571C162.824 18.0275 163.931 18.8483 165.341 19.4279C166.737 19.9936 168.282 20.2765 169.98 20.2765C171.525 20.2765 172.983 19.9797 174.316 19.3697C175.65 18.7457 176.591 18.0164 177.153 17.1512H169.192V11.9712H183.43V25.2041H177.486V24.0422C175.698 25.2485 173.316 25.8586 170.344 25.8586C167.372 25.8586 164.581 25.3067 162.247 24.2059Z"
                  fill="#2B3252"
                />
                <path
                  d="M188.225 1.01771H210.196V6.19774H194.169V10.5292H202.353V15.7093H194.169V20.0269H210.196V25.2069H188.225V1.01771Z"
                  fill="#2B3252"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M21.4145 8.92364C21.4145 9.84706 21.2394 10.7372 20.9116 11.5608C19.6912 14.6333 16.4027 16.8351 12.5323 16.8351H5.92148V25.0405H0V11.5608H12.5323C14.168 11.5608 15.493 10.3823 15.493 8.92364C15.493 7.46502 14.168 6.28648 12.5323 6.28648H8.88222V1.01771H12.5323C16.4027 1.01771 19.6912 3.21673 20.9116 6.28648C21.2365 7.11562 21.4145 7.99744 21.4145 8.92364Z"
                  fill="#2B3252"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.92148 1.01771H0V6.28925H5.92148V1.01771Z"
                  fill="#D5AF33"
                />
                <path
                  d="M253.643 25.2041V6.09791H259.587V25.2041H253.643Z"
                  fill="#D5AF33"
                />
                <path
                  d="M265.153 1.01771H278.801C281.318 1.01771 283.593 1.5224 285.669 2.52069C287.731 3.50235 289.384 4.9166 290.613 6.73294C291.842 8.54928 292.463 10.6762 292.463 13.1192C292.463 15.5623 291.842 17.6892 290.613 19.5056C289.384 21.3053 287.731 22.7195 285.669 23.7178C283.593 24.7161 281.318 25.2069 278.801 25.2069H265.153V1.01771ZM282.714 19.1617C283.881 18.596 284.807 17.7918 285.488 16.7658C286.172 15.7231 286.519 14.5196 286.519 13.1192C286.519 11.7189 286.172 10.4987 285.488 9.4727C284.805 8.43004 283.881 7.62586 282.714 7.06016C281.547 6.49446 280.242 6.19774 278.801 6.19774H271.097V20.0241H278.801C280.242 20.0241 281.547 19.7413 282.714 19.1617Z"
                  fill="#D5AF33"
                />
                <path
                  d="M298.026 1.01771H319.997V6.19774H303.97V10.5292H312.155V15.7093H303.97V20.0269H319.997V25.2069H298.026V1.01771Z"
                  fill="#D5AF33"
                />
                <path
                  d="M226.319 12.5868V25.1709H231.898V20.5454L226.319 12.5868Z"
                  fill="#2B3252"
                />
                <path
                  d="M242.329 17.0819C245.662 15.6788 247.603 12.9113 247.603 9.13439C247.603 3.48848 243.317 0 236.466 0H223.211L231.302 10.3296V4.74744H236.139C239.766 4.74744 241.597 6.36412 241.597 9.13439C241.597 11.9047 239.766 13.5213 236.139 13.5213H233.486L241.707 25.1709H248.081L242.329 17.0791V17.0819Z"
                  fill="#D5AF33"
                />
              </svg>
            </Link>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </div>

        {/* Navigation Links - Desktop */}
        <ul className="flex lg:hid display space-x-7 relative">
          <li
            className="relative"
            onMouseEnter={handleConsumerMouseEnter}
            onMouseLeave={handleConsumerMouseLeave}
          >
            <div className="secondary flex font-semibold text-lg cursor-pointer">
              Consumer Services
              <ChevronDownIcon className="h-7 w-7 text-gray-500 ml-1" />
            </div>
            {showConsumerDropdown && (
              <ul
                className="absolute shadow-md rounded-lg rounded-br-md pt-16 left-0 -mt-1 bg-white p-2 z-10"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <li className="secondary  bordersty mt-3 lg:w-[200px] p">
                  {products.map((item) => (
                    <Link
                      key={item.name}
                      href={item.href}
                      className=" block lg:w-[200px]  px-3 py-2 text-base font-semibold  secondary hover"
                    >
                      {item.name}
                    </Link>
                  ))}
                </li>
              </ul>
            )}
          </li>
          <li
            className="relative"
            onMouseEnter={handleBusinessMouseEnter}
            onMouseLeave={handleBusinessMouseLeave}
          >
            <div className="secondary flex font-semibold text-lg cursor-pointer">
              Business Services
              <ChevronDownIcon className="h-7 w-7 text-gray-500 ml-1" />
            </div>
            {showBusinessDropdown && (
              <ul
                className="absolute pt-16 left-0 rounded-bl-md rounded-br-md shadow-md -mt-1 bg-white p-2 z-10"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <li className="secondary bordersty mt-3 lg:w-[200px] p">
                  {Business.map((item) => (
                    <Link
                      key={item.name}
                      href={item.href}
                      className=" block lg:w-[200px]  px-3 py-2 text-base font-semibold  secondary hover"
                    >
                      {item.name}
                    </Link>
                  ))}
                </li>
              </ul>
            )}
          </li>

          <Link href="/about-us">
            {' '}
            <li className="secondary flex font-semibold text-lg cursor-pointer">
              About Us
            </li>
          </Link>
          <Link href="/blogs">
            {' '}
            <li className="secondary flex font-semibold text-lg cursor-pointer">
              Blog
            </li>
          </Link>

          <Link href={'/contact-us'}>
            {' '}
            <li
              className="relative"
              onMouseEnter={handleCompanyMouseEnter}
              onMouseLeave={handleCompanyMouseLeave}
            >
              <div className="secondary flex font-semibold text-lg cursor-pointer">
                Contact Us
              </div>
            </li>
          </Link>
          {/* ... (other menu items) */}
        </ul>
      </nav>

      <Dialog
        as="div"
        className="lg:hidden "
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-10" />

        <Dialog.Panel className="fixed  inset-y-0 right-0 ml-4 z-[999] w-[70%] h-[300px]   ">
          <div className="flex bg-white mt-12 ml-2  pt-2 items-center justify-between">
            <button
              type="button"
              className=" rounded-md border  text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon
                className="h-8 rounded-md border-1 border-[#2B3252] mkl-4 w-8"
                aria-hidden="true"
              />
            </button>
          </div>
          <div className="px-3 ml-2  flow-root bg-white">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <Disclosure as="div" className="-mx-3">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between rounded-lg mt-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-[#2b3252] ">
                        Consumer Services
                        <ChevronDownIcon
                          className={classNames(
                            open ? 'rotate-180' : '',
                            'h-5 w-5 flex-none'
                          )}
                          aria-hidden="true"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 space-y-2">
                        {[...products].map((item, index) => (
                          <Disclosure.Button
                            key={index}
                            as="a"
                            onClick={() => setMobileMenuOpen(false)}
                            href={item.href}
                            className="block hover rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-[#2b3252] hover:bg-gray-50"
                          >
                            {item.name}
                          </Disclosure.Button>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
                <Disclosure as="div" className="-mx-3">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-[#2b3252] ">
                        Business Services
                        <ChevronDownIcon
                          className={classNames(
                            open ? 'rotate-180' : '',
                            'h-5 w-5 flex-none'
                          )}
                          aria-hidden="true"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className=" space-y-2">
                        {[...Business].map((item, index) => (
                          <Disclosure.Button
                            key={index}
                            onClick={() => setMobileMenuOpen(false)}
                            as="a"
                            href={item.href}
                            className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-[#2b3252] hover:bg-gray-50"
                          >
                            {item.name}
                          </Disclosure.Button>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>

                {/*  */}
                <Link href="/about-us">
                  <li
                    onClick={() => setMobileMenuOpen(false)}
                    className="-mx-3 block rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-[#2b3252] hover:bg-gray-50"
                  >
                    About Us
                  </li>
                </Link>
                <Link href="/blogs">
                  <li
                    onClick={() => setMobileMenuOpen(false)}
                    className="-mx-3 block rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-[#2b3252] hover:bg-gray-50"
                  >
                    Blogs
                  </li>
                </Link>

                {/* <Disclosure as="div" className="-mx-3">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-[#2b3252] hover:bg-gray-50">
                        About Us
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 space-y-2">
                        {[...about].map((item, index) => (
                          <Disclosure.Button
                            key={index}
                            as="a"
                            href={item.href}
                            className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-[#2b3252] hover:bg-gray-50"
                          >
                            {item.name}
                          </Disclosure.Button>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure> */}

                {/*  */}

                <Link href="/contact-us">
                  <li
                    onClick={() => setMobileMenuOpen(false)}
                    className="-mx-3 block rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-[#2b3252] hover:bg-gray-50"
                  >
                    Contact Us
                  </li>
                </Link>
                <div className=" px-8">
                  <div className="border px-8"></div>
                </div>
                <div className="space-y-1 pl-1">
                  {contact.map((item, index) => (
                    <p key={index}>
                      <a
                        href={item.href}
                        className="-mx-3 block rounded-lg py-2 pl-3 pr-3.5 text-sm font-semibold leading-7 text-[#2b3252] hover:bg-gray-50"
                      >
                        <span className="flex gap-2 text-[#2b3252]">
                          {' '}
                          <span className="pt-1">{item.icon}</span>
                          <span className="-">{item.title}</span>
                        </span>
                      </a>
                    </p>
                  ))}
                </div>
                <div className="flex space-x-4 pl-1">
                  {social.map((item) => (
                    <a
                      target="blank"
                      key={item.name}
                      href={item.href}
                      className="text-white hover:text-gray-400 text-xl"
                    >
                      <div className="text-[#2b3252]">{item.icon}</div>
                    </a>
                  ))}
                </div>
              </div>
              <div className="p-3 -ml-4">
                {/* <Link href="/">
                  <button className="buttoncolor font-semibold pr-6 pl-5 pt-2 rounded-md pb-2">
                    Get a Qoute
                  </button>
                </Link> */}
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}
